import React from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebook, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faVoicemail } from "@fortawesome/free-solid-svg-icons";
import { NavHashLink } from "react-router-hash-link";
import { animateScroll as scroll } from 'react-scroll';

const Footer = () => {

    const scrollToTop = () => {
        scroll.scrollToTop();
    }

    return (
        <div className="flex justify-center bg-third text-white">
            <div className="container px-12 md:px-0">
                <div className="pt-8 md:flex md:pt-12 justify-between">
                    <div className="md:w-2/3">
                        <div className="text-start">
                            <h1 className="font-logo text-4xl lg:text-5xl py-4"><span className="text-fifth">Banraas</span>,Gili Iyang</h1>
                            <div className="my-3 flex gap-2">
                                <FontAwesomeIcon className="text-3xl w-5 my-auto" icon={faEnvelope} />
                                <h4 className="my-auto">giliiyang.official@gmail.com</h4>
                            </div>
                            <h4>#Oksigen #Budaya #Religi</h4>
                        </div>
                        <div className="pt-4 md:pt-8 flex flex-row gap-6">
                            <a className="flex py-1" target="_blank" rel="noreferrer" href="https://www.instagram.com/giliiyang_official/">
                                <FontAwesomeIcon className="text-3xl w-8 my-auto" icon={faInstagram} />
                            </a>
                            <NavLink className="flex py-1">
                                <FontAwesomeIcon className="text-3xl w-8 my-auto" icon={faFacebook} />
                            </NavLink>
                            <NavLink className="flex py-1">
                                <FontAwesomeIcon className="text-3xl w-8 my-auto" icon={faYoutube} />
                            </NavLink>
                            <NavLink className="flex py-1">
                                <FontAwesomeIcon className="text-3xl w-8 my-auto" icon={faTiktok} />
                            </NavLink>
                        </div>
                    </div>
                    <div className="md:flex md:w-2/3 justify-end py-4">
                        <div className="md:w-full justify-end md:flex md:flex-row gap-6">
                            <NavHashLink
                                to="/#"
                                smooth="true"
                                className="flex py-1">Home</NavHashLink>
                            <NavHashLink
                                smooth="true"
                                to="/#paket-wisata"
                                className="flex py-1">Paket Wisata</NavHashLink>
                            <NavLink
                                smooth="true"
                                onClick={scrollToTop}
                                to="/tentang-gili-iyang"
                                className="flex py-1">Tentang Gili Iyang</NavLink>
                            <NavHashLink
                                smooth="true"
                                to="/#contact"
                                className="flex py-1">Contact Us</NavHashLink>
                            <NavLink
                                smooth="true"
                                className="flex py-1">Tentang Kami</NavLink>
                        </div>
                    </div>
                </div>
                <hr className="mt-4 border-gray-400" />
                <div className="py-6 text-sm">
                    Gili Iyang Dungkek Sumenep 2023
                </div>
            </div>
        </div>
    )
}

export default Footer;